import { render, staticRenderFns } from "./ContractorDocumentTypesPage.vue?vue&type=template&id=2d655c7b"
import script from "./ContractorDocumentTypesPage.vue?vue&type=script&lang=js"
export * from "./ContractorDocumentTypesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports